/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useEffect } from "react";
import { Tooltip, Typography } from "@mui/material";
import AppLink from "../AppLink";
import { useViewHistory } from "../ViewHistoryContext";
import BreadcrumbModel from "./BreadcrumbModel";

export interface BreadcrumbProps {
    url: string;
    caption: string;
    isMainView?: boolean
}

// Das SCSS des Breadcrumbs muss in der App importiert werden
export default function Breadcrumb({ url, caption, isMainView }: BreadcrumbProps) {
    const vm = new BreadcrumbModel();
    const viewHistory = useViewHistory();
    useEffect(viewHistory.register({ url, isMainView }), [url]);
    return (
        <AppLink to={url}>
            <Tooltip
                classes={{
                    tooltip: "lan-breadcrumb__tooltip"
                }}
                title={caption}
                disableFocusListener
                disableHoverListener={vm.disableHoverListener}
            >
                <Typography
                    ref={vm.handleHoverListenerState}
                    component="div"
                    className="lan-breadcrumb__caption lan-breadcrumb__caption-clarity"
                    noWrap
                >
                    {caption}
                </Typography>
            </Tooltip>
        </AppLink>
    );
}
